import { Modal, Button, Form } from 'react-bootstrap';
import Img from '../../../assets/images/slider-home.jpg';
// scss
import './TopbarLP.scss';
function LoginModal(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
    >
      <section>
        <div className='LoginModal'>
          <div className='row'>
            <div className='col-lg-6'>
              <div className='login-label'>
                <p className='h6'>
                  Welcome <span className='line-welcome'>----</span>
                </p>
                <p className='h5'>Log In To Your Account</p>
                <form onSubmit={props.signInHandler}>
                  <Form.Group>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type='email' />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control type='password' />
                  </Form.Group>
                  <Form.Group
                    className='mb-3'
                    controlId='rememberme'
                  >
                    <Form.Check
                      type='checkbox'
                      label='Remember Me'
                    />
                  </Form.Group>
                  <div className='text-center'>
                    <Button
                      type='submit'
                      classname='text-center px-3'
                    >
                      SIGN IN
                    </Button>
                  </div>
                </form>
              </div>
            </div>
            <div className='col-lg-6 img-label'>
              <img
                alt='img'
                src={Img}
                className='img-fluid'
              />
              <div className='text-container'>
                <h6>
                  {' '}
                  <span className='line'>----</span> Sign in to your account
                </h6>
                <h5>LOG IN TO ENROLL ON THE COURSES</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Modal>
  );
}

export default LoginModal;
